import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
	Home,
	FileText,
	PlusCircle,
	Target,
	Briefcase,
	Search,
	Coins,
	Users,
	ChevronLeft,
	ChevronRight
} from 'lucide-react';

const items = [
	{ to: '/dashboard', label: 'Dashboard', icon: Home },
	{ to: '/resumes', label: 'My Resumes', icon: FileText },
	{ to: '/resumes/new', label: 'Create Resume', icon: PlusCircle },
	{ to: '/ats-analyzer', label: 'ATS Analyzer', icon: Target },
	{ to: '/job-matcher', label: 'Job Matcher', icon: Briefcase },
	{ to: '/jobs', label: 'Browse Jobs', icon: Search },
	{ to: '/credits', label: 'Credits', icon: Coins },
	{ to: '/referrals', label: 'Referrals', icon: Users }
];

export default function Sidebar() {
	const [collapsed, setCollapsed] = useState(false);
	const linkClass = ({ isActive }) =>
		`flex items-center gap-3 px-3 py-2 rounded-md text-sm ${
			isActive ? 'bg-primary-50 text-primary-700' : 'text-gray-700 hover:bg-gray-50'
		}`;

	return (
		<aside className={`bg-white border-r border-gray-200 h-full ${collapsed ? 'w-16' : 'w-60'} transition-all`}>
			<div className="p-2 flex justify-end">
				<button
					className="p-1 rounded hover:bg-gray-100"
					onClick={() => setCollapsed((v) => !v)}
					aria-label="Toggle sidebar"
				>
					{collapsed ? <ChevronRight className="w-5 h-5" /> : <ChevronLeft className="w-5 h-5" />}
				</button>
			</div>
			<nav className="px-2 space-y-1">
				{items.map(({ to, label, icon: Icon }) => (
					<NavLink key={to} to={to} className={linkClass}>
						<Icon className="w-5 h-5" />
						{!collapsed && <span>{label}</span>}
					</NavLink>
				))}
			</nav>
			<div className="mt-auto p-3 text-xs text-gray-500">{/* Credits could render here if desired */}</div>
		</aside>
	);
}


